import styled from 'styled-components';
import Icon from '../Icons/Icon';

export const SocialShare = styled.nav`
  display: flex;
  flex-direction: row;
`;

export const Link = styled.a`
  text-decoration: none;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
`;

export const SocialIcon = styled(Icon)`
  height: 20px;
  color: var(--background);
`;
